import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import 'shared/string.extensions';
import App from './App';
import './Sentry';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter as Router } from 'react-router-dom';
import ScrollToTop from './ScrollToTop';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
    <Router>
        <ScrollToTop />
        <App />
    </Router>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
